/* eslint-disable comma-dangle */
/* eslint-disable indent */
/* eslint-disable require-jsdoc */
import React, {useState, useEffect} from 'react';
import validator from 'validator';
import Axios from 'axios';
// import {fetchedArticles} from '../utils/backupArticles';
import {BASE_URL} from '../utils/baseUrl';
import '../css/NewsroomMenu.css';

/**
 * The news room menu for the top section of the website
 * @return {Component} NewsroomMenu component
 */
export default function NewsroomMenu() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [buttonLabel, setButtonLabel] = useState('Sign Up');
  const [refreshCount, setRefreshCount] = useState(0);
  const [fetchedArticles, setFetchedArticles] = useState([]);
  const [articleIdx, setArticleIdx] = useState([]);
  const [newsroomContent, setNewsroomContent] = useState([]);

  // Get featured articles
  useEffect(() => {
    Axios.get(`${BASE_URL}/api/articles/articleOrder`).then((res) => {
      const data = res.data;
      setArticleIdx(data.articles);
    });

    Axios.get(`${BASE_URL}/api/articles`).then((res) => {
      setFetchedArticles(res.data);
    });

    console.log(fetchedArticles.length, articleIdx.length);

    if (articleIdx.length === 0 || fetchedArticles.length === 0) {
      setTimeout(() => setRefreshCount(refreshCount + 1), 1000);
    } else {
      const newArr = matchArticlesToIdx(fetchedArticles, articleIdx);
      setNewsroomContent(newArr);
    }
  }, [refreshCount]);

  function matchArticlesToIdx(item, itemIdx) {
    const result = [];
    for (let i = 0; i < 4; i++) {
      for (let j = 0; j < item.length; j++) {
        if (item[j]._id === itemIdx[i]) {
          result.push(item[j]);
        }
      }
    }
    return result;
  }

  const handleSubmit = (event) => {
    if (validator.isEmail(email)) {
      setButtonLabel('Opt-In Successful');
      setEmailError('');

      const data = {
        email: email,
      };

      Axios.post(`${BASE_URL}/api/recipients`, data)
        .then('opted in')
        .catch((err) => {
          console.error('Something went wrong!', err);
        });
    } else {
      setEmailError('Please enter a valid email.');
    }

    event.preventDefault();
  };

  return (
    <div className="newsroom-menu-root">
      <div className="newsroom-menu-overlay" />
      <div className="newsroom-menu-container">
        <h1 style={{fontFamily: 'CenturyGothic', textTransform: 'uppercase'}}>
          Latest From The Newsroom
        </h1>
        <div className="newsroom-menu-content">
          {newsroomContent.length === 4 ? (
            newsroomContent.map((post, index) =>
              post.active ? (
                <a className="newsroom-menu-post" key={index} href={post.link}>
                  <div>
                    <h3>
                      {post.category}&nbsp; • &nbsp;{post.date}
                    </h3>
                    <p>{post.title}</p>
                  </div>
                  <div style={{width: '40px'}} />
                  <img src={post.image} />
                </a>
              ) : (
                <></>
              )
            )
          ) : (
            <div className="newsroom-menu-loading">
              <div className="newsroom-loader" />
            </div>
          )}
        </div>
        <br />
        <a href="/newsroom">
          <button>Explore All</button>
        </a>
      </div>
      <div style={{width: '40px'}}></div>
      <div className="newsroom-menu-right-container">
        <h2 style={{fontFamily: 'CenturyGothic', textTransform: 'uppercase'}}>
          Updates by E-Mail
        </h2>
        <p>
          Get the latest news from the biotechnology industry by registering for
          monthly updates with Advanced Intelligence Services Corp.
        </p>
        <form>
          <p>{emailError}</p>
          <input
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
          <button onClick={handleSubmit}>{buttonLabel}</button>
        </form>
        <br />
        <br />
        <p>
          By subscribing you agree to our&nbsp;
          <a style={{color: 'lightBlue'}} href="/termsofuse">
            Terms of Use
          </a>
          &nbsp; and&nbsp;
          <a style={{color: 'lightBlue'}} href="/privacypolicy">
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>
  );
}
